'use strict';

angular.module('shiftTraderApp')
  .factory('Subscriptions', function (ServerUrls, $http, Session, $q) {
    var path = ServerUrls.current.railsApi + 'organizations/';


    var Subscription = function(initData, linkedOrg) {
      var subs = {};
      angular.extend(subs, initData);

      var init = function(d, o) {
        angular.extend(subs, d);
        subs._canceled_at = moment.utc(d.canceled_at * 1000).tz(Session.getTimezone());
        subs._current_period_start = moment.utc(d.current_period_start * 1000).tz(Session.getTimezone());
        subs._current_period_end = moment.utc(d.current_period_end * 1000).tz(Session.getTimezone());
        subs._start = moment.utc(d.start * 1000).tz(Session.getTimezone());
        subs._trial_end = moment.utc(d.trial_end * 1000).tz(Session.getTimezone());
        subs.organization = o;
      };

      init(initData, linkedOrg);


      subs.$isInTrialPeriod = function() {
        return subs.status === 'trialing';
      };

      subs.$isPastDue = function() {
        return subs.status === 'past_due';
      };

      subs.$isCanceled = function() {
        return subs.status === 'canceled';
      };

      subs.$isActive = function() {
        return subs.status === 'active';
      };

      subs.$shortStatusInWords = function() {
        if (subs.$isActive()) {
          if (subs.cancel_at_period_end) {
            return 'Active but will not renew';
          } else {
            return 'Active';
          }
        } else if (subs.$isCanceled()) {
          return 'Canceled';
        } else if (subs.$isPastDue()) {
          return 'Past Due';
        } else if (subs.$isInTrialPeriod()) {
          if (subs.cancel_at_period_end) {
            return 'Trialing but will not renew';
          } else {
            return 'Trialing, renewing at end of trial';
          }
        }
      };

      subs.$cancel = function(data) {
        var localThis = this;
        // IE8 doesn't like $http.delete name
        return $http['delete'](path + subs.organization.id + '/subscriptions/' +  subs.id, data)
          .then(function(response) {
            init(response.data, subs.organization);
            return subs;
          }, function(response) {
            return $q.reject(response);
          });
      };

      subs.$restartSubscription = function() {
        var localThis = this;
        var data = {
          action: 'restart'
        };

        return $http.put(path + subs.organization.id + '/subscriptions/' + subs.id, data)
          .then(function(response) {
            init(response.data, subs.organization);
            return subs;
          }, function(response) {
            return $q.reject(response);
          });
      };

      return subs;
    };

    var Subscriptions = {};

      Subscriptions.initWithData = function(initData, linkedOrg) {
        return new Subscription(initData, linkedOrg);
      };

    return Subscriptions;
  });
